<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <c-container>
    <c-row class="justify-content-center">
      <c-col md="9">
        <c-card-group>
          <c-card class="p-4">
            <c-card-body>
              <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <h1>Login</h1>
                <p class="text-medium-emphasis">Sign In to your account</p>
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input name="username" formControlName="username" autoComplete="username" cFormControl
                    placeholder="Username" (input)="onUsernameInput($event)" />
                </c-input-group>
                <div *ngIf="loginForm.get('username')?.invalid 
            && (loginForm.get('username')?.dirty || loginForm.get('username')?.touched)"
                  class="text-danger small mb-2">

                  <span *ngIf="loginForm.get('username')?.errors?.['required']">
                    Email is required.
                  </span>

                  <span *ngIf="loginForm.get('username')?.errors?.['email']">
                     Please enter your IIIT-B email ID 
                  </span>

                </div>
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input name="password" formControlName="password" autoComplete="current-password" cFormControl
                    placeholder="Password" type="password" />
                </c-input-group>
                <c-row>
                  <c-col xs="6">
                    <button [disabled]="loginForm.invalid" type="submit" cButton class="px-4" color="primary">
                      Login
                    </button>
                  </c-col>
                  <c-col class="text-end" xs="6">
                    <button [routerLink]="['/forgot_password']" cButton class="px-0" color="link">
                      Forgot/Reset password?
                    </button>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>
            <c-card-body class="text-center">
              <button cButton class="mt-3" color="danger" routerLink="/calendar">
                Click here see Timetable Calendar
              </button>
            </c-card-body>
          </c-card>
          <c-card [ngStyle]="{'width.%': 44}" class="text-white bg-primary py-5">
            <c-card-body class="text-center d-flex justify-content-center align-items-center" style="height: 100%;">
              <div class="text-center">
                <img width="150px" height="150px" src="./assets/iiitb_logo.png" alt="IIITB Logo">
                <h2>Welcome to IIIT-B 360<sup>o</sup></h2>
              </div>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>